import axios from '../utils/axios';

/**
 * Get available months for a specific data type
 * @param {string} adminId - Admin ID
 * @param {string} type - Type of data ('history', 'logs', or 'metrics')
 * @returns {Promise} API response
 */
export default function fetchCronMonths(adminId, type) {
    return axios.get(`/admin/${adminId}/cron/months`, { 
        params: { type } 
    });
}
